interface TrackerButtonProps {
  name: string;
  min: number;
  max: number;
  descriptor?: string;
  bgColor?: string;
  fillColor?: string;
  barThickness?: number;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  onClick?: () => void;
}

const sizeClasses = {
  xs: { main: 'text-xs', sub: 'text-[0.625rem]' },
  sm: { main: 'text-sm', sub: 'text-xs' },
  md: { main: 'text-base', sub: 'text-sm' },
  lg: { main: 'text-lg', sub: 'text-base' },
  xl: { main: 'text-xl', sub: 'text-lg' },
};

export default function TrackerButton({
  name,
  min,
  max,
  descriptor = 'capacity',
  bgColor = 'bg-gray-200 dark:bg-gray-700',
  fillColor = 'bg-blue-500',
  barThickness = 8,
  size = 'sm',
  onClick,
}: TrackerButtonProps) {
  const percentage = max > 0 ? Math.min((min / max) * 100, 100) : 0;

  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full text-left p-3 rounded-lg border border-gray-200 dark:border-gray-700 bg-panel hover:border-gray-300 dark:hover:border-gray-600 hover:shadow-sm transition-all cursor-pointer"
    >
      <div className={`flex items-center justify-between ${sizeClasses[size].main} mb-2`}>
        <span className="font-medium text-heading">{name}</span>
        <span className="text-muted">
          {min}/{max}
        </span>
      </div>
      <div className={`w-full ${bgColor} rounded-full overflow-hidden`} style={{ height: barThickness }}>
        <div
          className={`h-full ${fillColor} transition-all duration-300 rounded-full`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className={`${sizeClasses[size].sub} text-gray-500 dark:text-gray-400 text-right mt-1`}>
        {descriptor} {Math.round(percentage)}%
      </div>
    </button>
  );
}
